import Box from '@/common/components/Box';
import GoBackButton from '@/common/components/GoBackButton';
import Skeleton from '@/common/components/Skeleton';
import Table from '@/common/components/Table';
import Tabs from '@/common/components/Tabs';
import { governmentAllocationSummaryCurrencyTableColumns } from '../constants/governmentAllocationSummaryTableColumns';

const ShowGovernmentAllocationLoadingState = () => {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <div className="flex gap-4 items-center">
          <GoBackButton fallback={`/government-allocations`} />

          <div className="flex items-center gap-1">
            <Skeleton width={240} />
          </div>
        </div>
      </div>

      <Box className="flex gap-6 items-start h-[calc(100vh-130px)] shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
        <div className="w-full flex flex-col gap-6 h-[calc(100vh-178px)] overflow-y-auto">
          <div className='flex items-end justify-between'>
            <Skeleton width={190} height={28} />

            <div className='flex items-center gap-2'>
              <Skeleton width={80} height={24} />
              <Skeleton width={190} height={40} className='bg-white-100' />
            </div>
          </div>

          <div className="flex gap-6">
            <div className='flex flex-col gap-1'>
              <Skeleton width={100} />
              <Skeleton width={120} height={24} />
            </div>

            <div className='flex flex-col gap-1'>
              <Skeleton width={100} />
              <Skeleton width={120} height={24} />
            </div>

            <div className='flex flex-col gap-1'>
              <Skeleton width={150} />
              <Skeleton width={180} height={24} />
            </div>

            <div className='flex flex-col gap-1'>
              <Skeleton width={150} />
              <Skeleton width={180} height={24} />
            </div>
          </div>

          <div className="flex gap-6">
            <div className='flex flex-col gap-1'>
              <Skeleton width={100} />
              <Skeleton width={130} height={24} />
            </div>

            <div className='flex flex-col gap-1'>
              <Skeleton width={100} />
              <Skeleton width={130} height={24} />
            </div>

            <div className='flex flex-col gap-1'>
              <Skeleton width={100} />
              <Skeleton width={130} height={24} />
            </div>

            <div className='flex flex-col gap-1'>
              <Skeleton width={100} />
              <Skeleton width={130} height={24} />
            </div>

            <div className='flex flex-col gap-1'>
              <Skeleton width={100} />
              <Skeleton width={130} height={24} />
            </div>
          </div>

          <Tabs
            tabsListClassName="w-full bg-transparent rounded-none"
            tabsTriggerClassName="h-8 w-full rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
            tabsContentClassName="mt-6"
            tabsList={[
              {
                label: 'Resumo de Distribuições',
                value: '',
                body: (
                  <div className="flex flex-col gap-6">
                    <div className='flex justify-end'>
                      <Skeleton width={190} height={40} className='bg-white-100' />
                    </div>

                    <Table
                      className="min-h-[256px] max-h-[calc(100vh-496px)]"
                      columns={governmentAllocationSummaryCurrencyTableColumns}
                      rows={[]}
                      page={1}
                      totalPages={1}
                      isLoadingData
                      loadingRows={2}
                      rowEmptyValue="--"
                    />
                  </div>
                ),
                disabled: true,
              },
              {
                label: 'Documentos de empenho',
                value: 'documents',
                body: <></>,
                disabled: true,
              },
              {
                label: 'Divisão de crédito do empenho',
                value: 'distribution',
                body: <></>,
                disabled: true,
              },
              {
                label: 'Faturas do empenho',
                value: 'bills',
                body: <></>,
                disabled: true,
              },
            ]}
          />
        </div>
      </Box>
    </div>
  )
}

export default ShowGovernmentAllocationLoadingState
